import axios from 'axios/index'
let baseUrl = process.env.API_URL;

export default {
  /**
   * The getProducts Function
   *
   * Function that allow the user to get products based on the page param in the language responding with the language param.
   *
   * @param language string   Contains the language in which the products need to be gotten
   * @param page     int      Contains the page of the products to be gotten
   * @param callback function Contains the function that needs to be executed after the HTTP get request
   *
   * @return Returns response data to the corresponding callback function
   */
  getProducts(language = 'nl-be', page = 1, callback) {
    axios.get(
      baseUrl + language + 'product?q=cr60&p=' + page,
    ).then(
      response =>
        callback(response.data)
    ).catch(
      e =>
        console.log('the following error occured: ' + e)
    )
  },
  /**
   * The getProducts Function
   *
   * Function that allow the user to get products based on the page param in the language responding with the language param.
   *
   * @param query    string   Contains the name of the products to be gotten
   * @param language string   Contains the language in which the products need to be gotten
   * @param callback function Contains the function that needs to be executed after the HTTP get request
   *
   * @return Returns response data to the corresponding callback function
   */
  getProductsByName(query, language = 'nl-be', callback) {
    axios.get(
      baseUrl  + 'search?q=' + query,
    ).then(
      response =>
        callback(response.data)
    ).catch(
      e =>
        console.log('the following error occured: ' + e)
    )
  },
  /**
   * The getFilters Function
   *
   * Function that allows a user to filter products in order to find the preferred product.xc
   *
   * @param language string   Contains the language in which te filters need to be gotten.
   * @param callback function Contains the function that needs to be executed after the HTTP get request
   */
  getFilters(params, language = 'nl-be', callback){
      axios.get(
          baseUrl + 'filters?' + params,
      ).then(
          response =>
              callback(response.data)
  ).catch(
          e =>
      console.log('the following error occured: ' + e)
  )
  },
  /**
   * The postFilters Function
   *
   * Allows a user to send the active filters to backend to get the correct products
   *
   * @param filters  string   Json string with filters
   * @param language string   Contains the language in which data needs to be gotten
   * @param callback function Contains the function that needs to be executed after the HTTP post request
   */
  postFilters(filters, productsIds, reset, language = 'nl-be', callback) {
      axios.post(
          baseUrl + 'post-filters',
          {
              filters: filters,
              searchedProducts: productsIds,
              reset: reset
          }
      ).then(
          response =>
      callback(response.data)
  ).catch(
          e =>
      console.log('the following error occured: ' + e)
  )
  },
    /**
     * The resetFilters Function
     *
     * Allows a user to reset the active filters to backend to hide products
     *
     * @param language string   Contains the language in which data needs to be gotten
     * @param callback function Contains the function that needs to be executed after the HTTP post request
     */
    resetFilters(language = 'nl-be', callback) {
        axios.get(
            baseUrl + 'reset-filters',
            {

            }
        ).then(
            response =>
        callback(response.data)
    ).catch(
            e =>
        console.log('the following error occured: ' + e)
    )
    },
  /**
  * The getMechanisms Function
  *
  * Allows a user to reset the active filters to backend to hide products
  *
  * @param language string   Contains the language in which data needs to be gotten
  * @param articleId integer id to search a mechanism
  * @param callback function Contains the function that needs to be executed after the HTTP post request
  */
  getMechanisms(articleid, language = 'nl-be', callback) {
        axios.get(
            baseUrl + 'getmecs?articleid=' + articleid
        ).then(
            response =>
        callback(response.data)
    ).catch(
            e =>
        console.log('the following error occured: ' + e)
    )
  },

/**
 * The getOptionss Function
 *
 * Allows a user to reset the active filters to backend to hide products
 *
 * @param language string   Contains the language in which data needs to be gotten
 * @param articleId integer id to search a mechanism
 * @param callback function Contains the function that needs to be executed after the HTTP post request
 */
 getOptions(articleid, language = 'nl-be', callback) {
    axios.get(
        baseUrl + 'getoptions?articleid=' + articleid
    ).then(
        response =>
    callback(response.data)
    ).catch(
            e =>
        console.log('the following error occured: ' + e)
    )
 },
 /**
  * The getOptionss Function
  *
  * Allows a user to reset the active filters to backend to hide products
  *
  * @param language string   Contains the language in which data needs to be gotten
  * @param articleId integer id to search a mechanism
  * @param callback function Contains the function that needs to be executed after the HTTP post request
  */
  getKaders(articleid, language = 'nl-be', callback) {
        axios.get(
            baseUrl + 'getkaders?articleid=' + articleid
        ).then(
            response =>
        callback(response.data)
    ).catch(
            e =>
        console.log('the following error occured: ' + e)
    )
  },
  getAllproducts(language = 'nl-be', callback) {
        axios.get(
            baseUrl + 'getallproducts'
        ).then(
            response =>
        callback(response.data)
    ).catch(
            e =>
        console.log('the following error occured: ' + e)
    )
    },
  getProductsById(productId, language = 'nl-be', callback) {
        axios.get(
            baseUrl + 'get-products-by-productId?productId=' + productId
        ).then(
            response =>
        callback(response.data)
    ).catch(
            e =>
        console.log('the following error occured: ' + e)
    )
    },
    //Send data to make excel
    sendExcelData(confData, language = 'nl-be', total) {
        axios.post(
            baseUrl + 'makeexcel',
            {
                total: total,
                language: language,
                contentData: confData
            }
        ).then(
            response => {
                let link = baseUrl + response.data;
                window.open(link, '_self')
            }

        ).catch(
            e =>
                console.log('the following error occured: ' + e)
        )
    },
     //Send data to make excel
    sendPdfData(confData, language = 'nl-be', total = 0, callback) {
        let vm = this;
        axios.post(
            baseUrl + 'makepdf',
            {
                contentData: confData,
                language: language,
                total: total
            }
        ).then(
            response => {
                callback(baseUrl + response.data)
            }

        ).catch(
            e =>
                console.log('the following error occured: ' + e)
        )
    },
     //Send data to make excel
    sendOrderData(confData, orderData, language = 'nl-be', total = 0, callback) {
        axios.post(
            baseUrl + 'send-order',
            {
                contentData: confData,
                orderData: orderData,
                language: language,
                total: total
            }
        ).then(
            response => {
                callback(baseUrl + response.data)
            }

        ).catch(
            e =>
                console.log('the following error occured: ' + e)
        )
    },
    getPdf(pdfUrl, language = 'nl-be', callback) {
        axios({
            method: 'get',
            url: pdfUrl,
            responseType: 'arraybuffer'
        })
            .then(response => {

                callback(response)

            })
            .catch(() => console.log('error occured'))
    },
    getTranslations(language = 'nl-be', callback) {
        axios.get(
            baseUrl + 'gettranslations'
        ).then(
            response =>
                callback(response.data)
        ).catch(
            e =>
                console.log('the following error occured: ' + e)
        )
    }
}


// WEBPACK FOOTER //
// ./src/services/request.js